import { axiosRequest, METHOD } from '@/api/default.js';
import constants from '@/constants/index.js';

// GET /api-v2/admin/system_settings
export async function getSystemSettings() {
    return await axiosRequest({
        url: constants.URL.SYSTEM_SETTINGS,
        method: METHOD.GET,
        requestName: 'LOAD SYSTEM SETTINGS',
        isLoader: true,
    });
}

// POST /api-v2/admin/system_settings
export async function updateSystemSettings(settings) {
    return await axiosRequest({
        url: constants.URL.SYSTEM_SETTINGS,
        method: METHOD.POST,
        requestName: 'UPDATE SYSTEM SETTINGS',
        data: { settings },
        isLoader: true,
        isShowPopup: true,
    });
}
